// extracted by mini-css-extract-plugin
module.exports = {"aside":"Aside_aside__73TjM","logo":"Aside_logo__3XaZ_"};